import { defineStore } from 'pinia';
import { ref } from 'vue';

/**
 * Overlays globaux ouverts depuis la nav (au lieu d'une navigation pleine page).
 * Les modales (InboxModal / InventoryModal) sont montées une fois dans AppLayout
 * et pilotées par ces drapeaux. Les routes /inbox et /inventory restent des
 * deep-links (la vue s'affiche alors en pleine page).
 */
export const useOverlaysStore = defineStore('overlays', () => {
  const inboxOpen = ref(false);
  const inventoryOpen = ref(false);
  const rewardChestsOpen = ref(false);
  const questsOpen = ref(false);
  const researchGlobalOpen = ref(false);
  const chatOpen = ref(false);

  function openInbox(): void { inboxOpen.value = true; }
  function openInventory(): void { inventoryOpen.value = true; }
  function openRewardChests(): void { rewardChestsOpen.value = true; }
  function openQuests(): void { questsOpen.value = true; }
  function openResearchGlobal(): void { researchGlobalOpen.value = true; }
  function openChat(): void { chatOpen.value = true; }
  function closeAll(): void {
    inboxOpen.value = false;
    inventoryOpen.value = false;
    rewardChestsOpen.value = false;
    questsOpen.value = false;
    researchGlobalOpen.value = false;
    chatOpen.value = false;
  }

  return {
    inboxOpen, inventoryOpen, rewardChestsOpen, questsOpen, researchGlobalOpen, chatOpen,
    openInbox, openInventory, openRewardChests, openQuests, openResearchGlobal, openChat,
    closeAll,
  };
});
